<div class="flex items-center justify-center">
  <fa-icon [icon]="faSpinner" animation="spin" size="xl" class="text-gray-500"></fa-icon>
</div>
